import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./FeuE1AdequacyMonitoringPlan.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { FeuECommonColumns } from "../../FeuConstants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const FeuE1AdequacyMonitoringPlan = forwardRef(({ FeuE1AdequacyMonitoringPlanData, refetchMonitoringData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (FeuE1AdequacyMonitoringPlanData) {
            reset(prev => ({ ...prev, e1: FeuE1AdequacyMonitoringPlanData }));
        }
    }, [FeuE1AdequacyMonitoringPlanData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });


    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e1");
        const payload = {
            ...FeuECommonColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const FeuE1AdequacyMonitoringPlan = await callApi({
                method: "POST",
                url: API_ROUTES.E1(vesselMstId),
                data: payload,
            });
            if (FeuE1AdequacyMonitoringPlan?.isSuccess) {
                emitToasterMsg("success", "Table E.1", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e1: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.1", FeuE1AdequacyMonitoringPlan?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.1", error?.errorMessage);
        }
    };

    return (
        <div className="e1-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Regular check of the adequacy of the monitoring plan
                    </h6>
                </MDBCol>
            </MDBRow>

            {FeuECommonColumns.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e1.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e1_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="feue1_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >
                    Save
                </Button>
            </div>
        </div>
    );
});

export default FeuE1AdequacyMonitoringPlan;
